// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"836":"74a54138","1429":"50ec5457","5944":"663984c0","9898":"663984c0"}[chunkId] + ".chunk.css";
};